function getOrgFromStorage () {
  const orgStr = sessionStorage.getItem('org')
  if (!orgStr) return null

  try {
    return JSON.parse(orgStr)
  } catch (e) {
    console.error('解析机构信息失败', e)
    return null
  }
}

const state = {
  orgInfo: getOrgFromStorage(),

  ticket: {
    last: 0,
    token: ''
  }
}

const getters = {
  org_encrypt_secret: (state) => {
    return state.orgInfo && state.orgInfo.encrypt_secret
  },
  org_id: (state) => {
    return state.orgInfo && state.orgInfo.id
  },
  hospitalTitle: (state) => {
    if (state.orgInfo && state.orgInfo.name) {
      return state.orgInfo.name
    }
    return process.env.TITLE
  },

  ticket: (state) => {
    return state.ticket
  }
}

const mutations = {
  SET_ORG_INFO (state, orgInfo) {
    state.orgInfo = orgInfo
    if (orgInfo) {
      sessionStorage.setItem('org', JSON.stringify(orgInfo))
    } else {
      sessionStorage.removeItem('org')
    }
  },

  SET_TICKET (state, ticket) {
    state.ticket = ticket
  }
}

const actions = {
  setOrgInfo ({ commit }, orgInfo) {
    commit('SET_ORG_INFO', orgInfo)
  },

  setTicked ({ commit }, ticket) {
    commit('SET_TICKET', ticket)
  }
}

export default {
  namespaced: true,
  state,

  getters,
  mutations,
  actions
}
